export default __webpack_public_path__ + "static/media/amazon-logo-regular.eac149e1.svg";